// screens-pricing.tsx - Marketing: Pricing (placeholder - plans not yet decided)
// Exports: ScreenPricing
import { Link } from '../design/router';
import { Check, MarketingFooter, MarketingNav, SignupCta } from '../components/ui-shared';

function TierGhostLine({ w }: { w: number }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <Check />
      <span style={{ height: 9, width: w, borderRadius: 999, background: 'var(--ss-border-soft)' }} />
    </div>
  );
}

export interface PricingTier {
  name: string;
  lines: number[];
  featured?: boolean;
}

function TierCard({ tier }: { tier: PricingTier }) {
  const featured = tier.featured;
  return (
    <article className="ss-card" style={{
      padding: '36px 34px 38px',
      display: 'flex', flexDirection: 'column', gap: 0,
      position: 'relative',
      borderColor: featured ? 'var(--ss-accent-border)' : undefined,
      background: featured ? 'linear-gradient(180deg, var(--ss-accent-soft), transparent)' : undefined,
    }}>
      <h3 className="ss-display" style={{ fontSize: 24, color: 'var(--ss-text-2)' }}>{tier.name}</h3>
      <p style={{ color: 'var(--ss-text-3)', fontSize: 13.5, marginTop: 6 }}>Details to be confirmed</p>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, margin: '26px 0 4px' }}>
        <span className="ss-display" style={{ fontSize: 46, color: 'var(--ss-text-3)' }}>TBC</span>
        <span style={{ color: 'var(--ss-text-3)', fontSize: 13.5 }}>per month</span>
      </div>
      <span className="ss-btn ss-btn--ghost" style={{ margin: '22px 0 28px', opacity: 0.55, cursor: 'default' }}>Coming soon</span>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 13 }}>
        {tier.lines.map((w, i) => <TierGhostLine key={i} w={w} />)}
      </div>
    </article>
  );
}

export const PRICING_TIERS: PricingTier[] = [
  { name: 'Tier one', lines: [120, 96, 140, 84] },
  { name: 'Tier two', lines: [132, 108, 88, 150, 102], featured: true },
  { name: 'Tier three', lines: [110, 144, 92, 126, 96, 118] },
];

export function ScreenPricing() {
  const tiers = PRICING_TIERS;
  return (
    <div className="ss-screen">
      <MarketingNav active="Pricing" />
      <header style={{ padding: '96px clamp(20px, 6vw, 56px) 64px', textAlign: 'center' }}>
        <div style={{ maxWidth: 640, margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
          <span className="ss-eyebrow">Pricing</span>
          <h1 className="ss-display" style={{ fontSize: 'clamp(2.1rem, 8vw, 3.625rem)' }}>Free while we build.</h1>
          <p style={{ color: 'var(--ss-text-2)', fontSize: 17, textWrap: 'pretty' }}>
            Every part of Studio, including hosting, installable games and multiplayer, is free during early access. Paid plans will be announced here first.
          </p>
          <span style={{ fontFamily: 'var(--ss-sans)', fontWeight: 600, fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--ss-text-3)', border: '1px solid var(--ss-border)', borderRadius: 999, padding: '5px 14px', whiteSpace: 'nowrap' }}>Plans not yet final</span>
        </div>
      </header>
      <section style={{ padding: '0 clamp(20px, 6vw, 56px) 64px' }}>
        <div className="ss-grid-collapse" style={{ maxWidth: 1180, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20, alignItems: 'start' }}>
          {tiers.map((t) => <TierCard key={t.name} tier={t} />)}
        </div>
      </section>
      <section style={{ padding: '0 clamp(20px, 6vw, 56px) 120px' }}>
        <div className="set-card" style={{ maxWidth: 760, margin: '0 auto', flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 20, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <h3 style={{ fontSize: 15.5, fontWeight: 600 }}>Build now, decide later</h3>
            <span className="hint">Nothing you build or publish today is locked behind a plan. Plan details will land here first.</span>
          </div>
          <div style={{ display: 'flex', gap: 10, flexShrink: 0 }}>
            <Link className="ss-btn ss-btn--ghost ss-btn--sm" to="/contact">Talk to us</Link>
            <SignupCta label="Start building free" />
          </div>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
